import {
  required,
  minLength,
} from 'vuelidate/lib/validators'

const isAtLeast =
  field =>
    (to, vm) => {
      let from = vm[field]
      if (to && from) {
        return from <= to
      } else {
        return true
      }
    }

export default {
  ueberOrganisationseinheit: {
    name: {
      required,
      minLength: minLength(1)
    }
  },
  name: {
    required,
    minLength: minLength(1)
  },
  ende: {
    isAtLeast: isAtLeast('beginn')
  },
  kostenstelle: {
    required
  }
}



// WEBPACK FOOTER //
// ./src/validation/Organisationseinheit.js